import React, { useState } from "react";

import { Box, Button } from "@mui/material";

import {
  publishProduct,
  unpublishProduct,
} from "api/endpoints/content-library";
import GenericDialog from "components/shared/generic-dialog";

export const ProductDialog = ({
  open,
  onSuccess,
  productId,
  onClose,
  forPublish,
}: {
  open: boolean;
  onSuccess: () => void;
  onClose: () => void;
  productId: string;
  forPublish: boolean;
}) => {
  const [error, setError] = useState(false);
  const handleUnpublishProduct = () => {
    setError(false);
    unpublishProduct({ productId })
      .then(() => {
        onSuccess();
      })
      .catch(() => {
        setError(true);
      });
  };

  const handlePublishProduct = () => {
    setError(false);
    publishProduct({ productId })
      .then(() => {
        onSuccess();
      })
      .catch(() => {
        setError(true);
      });
  };

  const title = forPublish
    ? "Are you sure you want to publish the product?"
    : "Are you sure you want to unpublish the product?";
  const errMsg = forPublish
    ? "There was an error publishing product, please try again"
    : "There was an error unpublishing product, please try again";
  return (
    <GenericDialog
      title={title}
      open={open}
      handleDialogClose={() => {
        setError(false);
        onClose();
      }}
    >
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Button
          data-testid="unpublish-confirm-btn"
          variant="outlined"
          onClick={() =>
            forPublish ? handlePublishProduct() : handleUnpublishProduct()
          }
        >
          Yes
        </Button>
        <Button
          data-testid="unpublish-reject-btn"
          variant="outlined"
          color="error"
          onClick={() => onClose()}
        >
          No
        </Button>
      </Box>
      {error && <Box>{errMsg}</Box>}
    </GenericDialog>
  );
};
